import { z } from "zod";

export const CompanyFieldsSchema = z.object({
  id: z.number(),
  name: z.string(),
  importId: z.string(),
  importCode: z.string(),
  importTyp: z.string(),
  shortName: z.string(),
  nip: z.string(),
  addressStreet: z.string(),
  addressStreetNumber: z.string(),
  addressLocalNumber: z.string(),
  addressPostalCode: z.string(),
  addressCity: z.string(),
  addressCommunity: z.string(),
  addressCountry: z.string(),
  addressCounty: z.string(),
  addressProvince: z.string(),
  defaultPriceType: z.number(),
  defaultLanguage: z.string(),
  blockOrder: z.number(),
  createdAt: z.string(),
  creationType: z.number(),
  modificationDate: z.string(),
  vatHandling: z.string(),
});

export const PartialCompanyFieldsSchema = CompanyFieldsSchema.deepPartial();

export const CompanyExtraFieldsSchema = z.object({
  attributes: z.array(z.any()), // TODO: define schema
});

export const PartialCompanyExtraFieldsSchema =
  CompanyExtraFieldsSchema.deepPartial();

export const CompanySchema = z.intersection(
  CompanyFieldsSchema,
  CompanyExtraFieldsSchema
);

export type CompanyFields = z.infer<typeof CompanyFieldsSchema>;
export type PartialCompanyFields = z.infer<typeof PartialCompanyFieldsSchema>;
export type CompanyExtraFields = z.infer<typeof CompanyExtraFieldsSchema>;
export type PartialCompanyExtraFields = z.infer<
  typeof PartialCompanyExtraFieldsSchema
>;

export type Company = z.infer<typeof CompanySchema>;
export type CompanyPartial = z.infer<typeof PartialCompanyFieldsSchema>;
